import { parseISO } from "date-fns";

import { Link, TiVoTargetsSummary } from "components/elements";
import { Pill } from "components/elements/Pill";
import {
  TableRowColumn,
  ImgIcon,
  TableRow,
  GrabsonIcon,
  TableSubRow,
} from "components/layout";
import { ActionMenu, MenuItem } from "components/popups";
import { useToggle } from "hooks/utils";
import { trans } from "src/translations";
import { formatDateTime } from "utils/date";

import { getDetailsPath, getEditPath } from "../../utils";
import styles from "../ManifestList.scss";

export function ProviderManifestRow({
  provider,
  apps,
  isAppIntegrator,
  setSelectedId,
}) {
  const [expanded, toggleExpanded] = useToggle(false);
  const appId = provider.providerId;
  const app = appId && apps.find((app) => app?.id === appId);

  const renderManifestDetailRow = ({
    id,
    created_date,
    is_deleted,
    modified_date,
    targets,
  }) => {
    return (
      <TableSubRow key={id}>
        <TableRowColumn colspan="2" className={styles.targets}>
          <TiVoTargetsSummary targets={targets} to={getDetailsPath(id)} />
          {is_deleted && (
            <Pill
              className={styles.deleted}
              text={trans.APP_MANIFESTS_DELETED()}
            />
          )}
        </TableRowColumn>
        <TableRowColumn className={styles.dateColumn}>
          {formatDateTime(parseISO(String(created_date)))}
        </TableRowColumn>
        <TableRowColumn className={styles.dateColumn}>
          {formatDateTime(parseISO(String(modified_date)))}
        </TableRowColumn>
        <TableRowColumn>
          <ActionMenu alignment="left">
            <MenuItem to={getDetailsPath(id)}>
              {trans.APP_MANIFESTS_DETAILS()}
            </MenuItem>
            <MenuItem to={getEditPath(id)} disabled={!isAppIntegrator}>
              {trans.APP_MANIFESTS_EDIT_MANIFEST()}
            </MenuItem>
            <MenuItem
              onClick={() => setSelectedId(id)}
              disabled={!isAppIntegrator || is_deleted}
            >
              {trans.DELETE()}
            </MenuItem>
          </ActionMenu>
        </TableRowColumn>
      </TableSubRow>
    );
  };

  return (
    <>
      <TableRow>
        <TableRowColumn className={styles.name}>
          <div onClick={toggleExpanded}>
            <GrabsonIcon
              className={styles.extender}
              name={expanded ? "arrow-up" : "arrow-down"}
              font="micro"
            />
            <ImgIcon src={app?.icon || ""} className={styles.icon} />
          </div>
          {app ? (
            <Link to={app.path}>{app.name}</Link>
          ) : (
            <>
              <span>{appId}</span>
              <Pill text={trans.EXTERNAL()} />
            </>
          )}
        </TableRowColumn>
        <TableRowColumn colspan="4" className={styles.countsColumn}>
          {provider.manifests.length}
        </TableRowColumn>
      </TableRow>
      {expanded &&
        provider.manifests.map((manifest) => renderManifestDetailRow(manifest))}
    </>
  );
}
